var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddProductHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smart Buy icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/add-products/hover",
    transform: "translate(-5.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Smart-Buy-icon",
    transform: "translate(5.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7784959,0.343415256 C10.5853054,0.343415256 9.39265904,0.228943504 8.2005567,-3.38353684e-15 L0.388531762,3.15541715 C0.16375902,3.24620689 0.0364926266,3.48515399 0.0865817625,3.72233882 L1.01167886,8.10290942 C1.06824536,8.37076621 1.3297023,8.54332695 1.59822887,8.49003054 L4.78083674,7.8583554 L4.78083674,7.8583554 L4.78083674,18.8003151 C4.78083674,19.0764575 5.00469437,19.3003151 5.28083674,19.3003151 L18.5286871,19.3003151 C18.8048294,19.3003151 19.0286871,19.0764575 19.0286871,18.8003151 L19.0286871,7.8583554 L19.0286871,7.8583554 L22.2112949,8.49003054 C22.4798215,8.54332695 22.7412785,8.37076621 22.7978449,8.10290942 L23.722942,3.72233882 C23.7730312,3.48515399 23.6457648,3.24620689 23.420992,3.15541715 L15.6089671,-3.38353684e-15 L15.6089671,-3.38353684e-15 C14.24851,0.228943504 12.9716863,0.343415256 11.7784959,0.343415256 Z",
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(11.904762, 9.650158) scale(-1, 1) translate(-11.904762, -9.650158) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6217041,1.74523926 C10.6194241,1.74523926 9.50813587,1.63309733 8.28783931,1.40881348 L1.83443874,3.89078265 C1.60240677,3.98002183 1.47118031,4.22617788 1.52642217,4.46856353 L2.01759599,6.62369518 C2.07895784,6.89293362 2.34696232,7.06145088 2.61620076,7.00008903 C2.62313279,6.99850916 2.63003033,6.99678161 2.63688868,6.99490756 L5.84814453,6.11743164 L5.84814453,6.11743164 L5.84814453,17.3669434 C5.84814453,17.6430857 6.07200216,17.8669434 6.34814453,17.8669434 L16.9306641,17.8669434 C17.2068064,17.8669434 17.4306641,17.6430857 17.4306641,17.3669434 L17.4306641,6.11743164 L17.4306641,6.11743164 L20.9807964,7.00855494 C21.24863,7.0757842 21.5202521,6.91316225 21.5874814,6.64532865 C21.5881957,6.64248291 21.5888849,6.63963094 21.5895491,6.63677307 L22.0919864,4.4746225 C22.1489057,4.22968056 22.0150504,3.98057501 21.7793776,3.89285554 L15.1055908,1.40881348 L15.1055908,1.40881348 C13.7852796,1.63309733 12.6239841,1.74523926 11.6217041,1.74523926 Z",
    id: "Path",
    fill: "#5C7284",
    transform: "translate(11.810852, 9.637878) scale(-1, 1) translate(-11.810852, -9.637878) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08630952,0.998076227 C8.57333612,3.26430355 9.77309377,4.39741721 11.6855825,4.39741721 C13.5980711,4.39741721 14.8141652,3.26430355 15.3338648,0.998076227",
    id: "Path-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 15,
    y2: 11,
    id: "Path-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.95238095,
    y1: 11.047619,
    x2: 14.952381,
    y2: 11.047619,
    id: "Path-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(11.952381, 11.047619) rotate(-90.000000) translate(-11.952381, -11.047619) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddProductHover);
export default __webpack_public_path__ + "static/media/icon_add_product_hover.60431d03.svg";
export { ForwardRef as ReactComponent };